import { useState } from 'react'
import { DefaultDurations } from '../../../shared/lib/blockRanges'
import { GhostState } from './types'

type HasCollisionFn = (
  iso: string,
  durations: DefaultDurations,
  technicianId: string,
  excludeId?: string,
  excludeTaskId?: number,
) => boolean

interface Options {
  draft: { date: string } | null
  ghost: GhostState | null
  hasCollision: HasCollisionFn
  setDurations: (d: DefaultDurations) => void
  excludeTaskId?: number
}

/**
 * Encapsulates the collision-check + durations-change logic shared between
 * DraftAppointmentPanel and DraftTaskPanel.
 */
export function useCollisionAwareDurations({ draft, ghost, hasCollision, setDurations, excludeTaskId }: Options) {
  const [collisionWarning, setCollisionWarning] = useState(false)

  const tryDurationsChange = (durations: DefaultDurations) => {
    if (!ghost || !draft) {
      setDurations(durations)
      return
    }
    if (hasCollision(draft.date, durations, ghost.technicianId, undefined, excludeTaskId)) {
      setCollisionWarning(true)
      return
    }
    setCollisionWarning(false)
    setDurations(durations)
  }

  return { tryDurationsChange, collisionWarning }
}
